<template>
  <action-dispatcher
    action="membersSetup/getFAQs"
    :parameters="$route.params.id"
  >
    <div class="product-details-content-setup-step-05">
      <h5 class="text-semibold">FAQ</h5>
      <h5 class="text-dark-40 mb-4">
        Tire as dúvidas mais frequentes dos seus alunos com estas respostas.
      </h5>
      <draggable v-model="sortedQuestions" handle=".handle" group="questions">
        <question-item
          v-for="(question, i) in sortedQuestions"
          :key="`q-${i}`"
          :item="question"
          @remove="remove"
          @update="refresh"
          :index="i"
        />
      </draggable>

      <div
        v-if="!sortedQuestions.length"
        class="container centralize-row text-center pt-5 mb-6"
      >
        <div class="row justify-content-center">
          <div class="col-lg-5 d-flex flex-column align-items-center gap-4">
            <h2 class="text-semibold">Ainda não há nada aqui</h2>
            <img src="@/assets/images/no-content.svg" />
            <hr class="w-100" />
            <h2>Talvez você precise</h2>
            <snow-button
              @click="add"
              text="Adicionar pergunta"
              icon="ph ph-plus"
            />
          </div>
        </div>
      </div>

      <button-add-question v-else @click="add" />
    </div>
  </action-dispatcher>
</template>

<script>
import ButtonAddQuestion from "@/components/ButtonAddQuestion";
import draggable from "vuedraggable";
import { mapState } from "vuex";
import QuestionItem from "./faq/QuestionItem";

export default {
  components: { draggable, QuestionItem, ButtonAddQuestion },
  computed: {
    ...mapState("membersSetup", ["faqs"]),
    sortedQuestions: {
      get() {
        return [...this.faqs].sort((a, b) => a.sort - b.sort);
      },
      set(value) {
        const faqs = [...this.faqs];
        for (let i in faqs) {
          for (let j in value) {
            if (faqs[i].id === value[j].id) {
              faqs[i].sort = j;
            }
          }
        }
        this.saveOrder(faqs);
      }
    }
  },
  methods: {
    async refresh() {
      await this.$store.dispatch("membersSetup/getFAQs", this.$route.params.id);
    },
    async saveOrder(newFaqs) {
      const error_index = undefined;
      for (let i in newFaqs) {
        try {
          const payload = { ...newFaqs[i] };
          if (payload.company_id) {
            delete payload.company_id; // fix backend primary key error
          }
          await this.$store.dispatch("membersSetup/putFAQ", payload);
        } catch (e) {
          error_index = i;
        }
      }

      if (error_index) {
        this.$message.error(
          `Não foi possível salvar a pergunta ${error_index + 1}`
        );

        return;
      }

      this.refresh();
    },
    add() {
      this.$store.commit("membersSetup/setFaqs", [
        ...this.faqs,
        {
          question: "",
          answer: ""
        }
      ]);
    },
    remove(index) {
      this.$store.commit(
        "membersSetup/setFaqs",
        this.faqs.filter((_, i) => i !== index)
      );
    }
  }
};
</script>
